import React from 'react';
import ImportCSV from '../Commission/Settings/importCSV';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
const ImportCsvPage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <h2 className="header">Import CSV Files</h2>
      <div style={{ textAlign: 'center' }}>
        <Dropdown>
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            Type
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {/* <Dropdown.Item onClick={() => navigate('/remove-tags')}>Remove Tags</Dropdown.Item> */}
            <Dropdown.Item onClick={() => navigate('/commission-xilnex')}>
              Xilnex Commissions
            </Dropdown.Item>
            <Dropdown.Item onClick={() => navigate('/add-shopify-tags')}>
              Add Shopify Tags
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        {/* <ImportCSV /> */}
      </div>
    </div>
  );
};

export default ImportCsvPage;
